export const communityLinks={
 telegram:'https://t.me/+ycnelp0LSOYyYjNi',
 max:'https://max.ru/join/xc-7PgzgemZrnddPMz8BWHZwsTye317zY-DK__I3jhw',
 creator:'/messages?with=5',
};
